<template>
  <span>
    <!-- for  -->
    <b-dropdown
      split-variant="outline-primary"
      variant="primary"
      :text="meal_preferences.people | pluralize(`${meal_preferences.people} person`,`${meal_preferences.people} people`)"
      class
    >
      <b-dropdown-item
        @click="updatePeoplePreferences(option)"
        :key="index"
        v-for="(option,index) in options"
      >{{ option | pluralize(`${option} person`,`${option} people`) }}</b-dropdown-item>
    </b-dropdown>
    <!-- {{ suffix }} -->
  </span>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
    name: 'profile-question',
    props: {
        blok: Object
    },
    computed: {
        ...mapState({
            meal_preferences: state => state.profile.meal_preferences
        }),
        options: function() {
            return this.$props.blok ? this.$props.blok.options.split(/\r?\n/) : [1,2,4];
        },
        suffix: function() {
            return this.meal_preferences.people == 1 ? 'person' : 'people';
        }
    },
    methods: {
        ...mapActions("profile", ["updatePeoplePreferences"])
    }
}
</script>